var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"code-validator"}},[_c('CodeInput',{staticClass:"code-validator-container",attrs:{"field-width":45,"field-height":48,"require":"true","loading":false},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }